import React from 'react';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import CustomSelect from '../../../../components/CustomSelect/CustomSelect';
import SlotValueType, {
  SlotValueTypeLabels
} from '../../../../types/BotBuilder/SlotValueType';
import InlineEnumeratedSlotValue from '../../../../types/BotBuilder/InlineEnumeratedSlotValue';
import EnumeratedValuesManager from './EnumeratedValuesManager';
import DocumentUploadConfiguration from './DocumentUploadConfiguration';

interface NewVariableFormProps {
  newVariableName: string;
  newSlotType: SlotValueType | null;
  enumeratedValues: InlineEnumeratedSlotValue[];
  maxFileSize: number;
  allowedFileTypes: string[];
  onVariableNameChange: (value: string) => void;
  onSlotTypeChange: (slotType: SlotValueType) => void;
  onEnumeratedValuesChange: (values: InlineEnumeratedSlotValue[]) => void;
  onMaxFileSizeChange: (size: number) => void;
  onAllowedFileTypesChange: (types: string[]) => void;
  disabled?: boolean;
}

function NewVariableForm({
  newVariableName,
  newSlotType,
  enumeratedValues,
  maxFileSize,
  allowedFileTypes,
  onVariableNameChange,
  onSlotTypeChange,
  onEnumeratedValuesChange,
  onMaxFileSizeChange,
  onAllowedFileTypesChange,
  disabled = false
}: Readonly<NewVariableFormProps>): React.ReactElement {
  return (
    <>
      <CustomSelect
        label='Variable type'
        value={newSlotType ?? ''}
        onValueChange={(value) => onSlotTypeChange(value as SlotValueType)}
        placeholder='Select variable type'
        options={[
          {
            value: SlotValueType.FREE_TEXT,
            label: SlotValueTypeLabels[SlotValueType.FREE_TEXT]
          },
          {
            value: SlotValueType.NUMBER,
            label: SlotValueTypeLabels[SlotValueType.NUMBER]
          },
          {
            value: SlotValueType.DATE,
            label: SlotValueTypeLabels[SlotValueType.DATE]
          },
          {
            value: SlotValueType.EMAIL,
            label: SlotValueTypeLabels[SlotValueType.EMAIL]
          },
          {
            value: SlotValueType.ENUMERATED_VALUE,
            label: SlotValueTypeLabels[SlotValueType.ENUMERATED_VALUE]
          },
          {
            value: SlotValueType.DOCUMENT_UPLOAD,
            label: SlotValueTypeLabels[SlotValueType.DOCUMENT_UPLOAD]
          }
        ]}
        className='bg-white'
        disabled={disabled}
      />
      <CustomInput
        label='Variable name'
        value={newVariableName}
        onChange={(e) => onVariableNameChange(e.target.value)}
        placeholder='Enter variable name'
        className='bg-white'
        disabled={disabled}
      />
      {newSlotType === SlotValueType.ENUMERATED_VALUE && (
        <EnumeratedValuesManager
          enumeratedValues={enumeratedValues}
          onValuesChange={onEnumeratedValuesChange}
          disabled={disabled}
        />
      )}
      {newSlotType === SlotValueType.DOCUMENT_UPLOAD && (
        <DocumentUploadConfiguration
          maxFileSize={maxFileSize}
          allowedFileTypes={allowedFileTypes}
          onMaxFileSizeChange={onMaxFileSizeChange}
          onAllowedFileTypesChange={onAllowedFileTypesChange}
          disabled={disabled}
        />
      )}
    </>
  );
}

export default NewVariableForm;
